export default "__VITE_ASSET__CsD4uxVH__"